const host = location.hostname;
const wsProto = location.protocol === "https:" ? "wss:" : "ws:";

export const API_URL: string = import.meta.env.VITE_API_URL ?? `${location.protocol}//${host}:3000`;
export const GAME_URL: string = import.meta.env.VITE_GAME_URL ?? `${wsProto}//${host}:2567`;
